import type { SVGProps } from 'react';

interface SoyIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function SoyIcon({ className, ...props }: SoyIconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M4.32452 7.23731C4.01142 8.6769 4.61466 10.1801 5.79731 11.0395C6.67282 11.6757 7.71764 11.8801 8.78288 11.6825C8.42043 13.3503 9.30444 15.298 11.001 15.8002C12.4483 16.2277 14.0291 15.8969 15.4398 15.4838C15.5674 15.0995 15.6882 14.7127 15.7759 14.3156C16.1851 12.457 16.197 10.3523 14.3848 9.25206C13.5331 8.73544 12.655 8.62685 11.6706 8.76173C12.2202 6.14978 9.84812 3.72275 7.21225 4.31657C7.57215 2.72768 6.7596 0.837634 5.18472 0.263325C3.75362 -0.258388 2.00005 0.0826347 0.590224 0.529696C0.482169 0.610286 0.275417 1.43654 0.235428 1.61554C-0.114264 3.16795 -0.233379 5.12925 1.03351 6.30841C1.92348 7.13636 3.13081 7.41291 4.32538 7.23901L4.32452 7.23731Z" fill="currentColor" />
    </svg>
  );
}
